import type { NotificationActions } from '@features/components/Notification/notificationSlice';
import { io, type Socket } from 'socket.io-client';

interface Payload {
  action: NotificationActions;
  payload: string;
}

class SocketService {
  private socket: Socket;
  private serverUrl = import.meta.env.VITE_API_BASE_PATH;

  constructor() {
    this.socket = io(this.serverUrl);
  }

  bindUser(userId: string) {
    this.socket.emit('bindUser', userId);
  }

  onNotification(callback: (message: Payload) => void) {
    this.socket.on('notification', m => callback(JSON.parse(m)));
  }
}

export default SocketService;
